import { jsonFetch, typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import {
  CUSTOM_INTEGRATIONS_CREATE,
  CUSTOM_INTEGRATIONS_DELETE,
  CUSTOM_INTEGRATIONS_GET_ALL,
  CUSTOM_INTEGRATIONS_UPDATE,
} from "./api-url.constants";
import type {
  CreateCustomIntegrationApiDto,
  CustomIntegrationResponseApiDto,
  DeleteCustomIntegrationApiDto,
  UpdateCustomIntegrationApiDto,
} from "./dtos/custom-integrations.api.dto";

export const customIntegrationsApiService = {
  async create(data: CreateCustomIntegrationApiDto): Promise<CustomIntegrationResponseApiDto> {
    const url = CUSTOM_INTEGRATIONS_CREATE;

    const result = await jsonFetch<{ data: CustomIntegrationResponseApiDto }>(url, {
      method: API_METHODS.POST,
      body: JSON.stringify(data),
    });
    return result.data;
  },

  async update(data: UpdateCustomIntegrationApiDto): Promise<void> {
    const url = `${CUSTOM_INTEGRATIONS_UPDATE}/${data._id}`;

    await typedFetch(url, {
      method: API_METHODS.PUT,
      body: JSON.stringify({
        applicationName: data.applicationName,
      }),
    });
  },

  async delete(data: DeleteCustomIntegrationApiDto): Promise<void> {
    const url = `${CUSTOM_INTEGRATIONS_DELETE}/${data.integrationId}`;

    await typedFetch(url, {
      method: API_METHODS.DELETE,
    });
  },

  async getAll(userId: string): Promise<CustomIntegrationResponseApiDto[]> {
    const result = await jsonFetch<{ data: CustomIntegrationResponseApiDto[] }>(
      `${CUSTOM_INTEGRATIONS_GET_ALL.replace("{userId}", userId)}`,
      {
        method: API_METHODS.GET,
      }
    );
    return result.data;
  },
};
